<template>
  <div class="text-body text-black-2">
    {{ text || "-" }}
  </div>
</template>

<script setup>
defineProps({ text: { type: [String, Number], default: null } });
</script>
